// Simple offline-queue for refuel submissions.
// Stored in localStorage under FT_QUEUE_KEY as a JSON array.
// Each entry: { id, payload, queued_at }

import { api } from "@/lib/api";

const FT_QUEUE_KEY = "ft_pending_refuels";

function readQueue() {
  try {
    return JSON.parse(localStorage.getItem(FT_QUEUE_KEY) || "[]");
  } catch {
    return [];
  }
}
function writeQueue(q) {
  localStorage.setItem(FT_QUEUE_KEY, JSON.stringify(q));
  window.dispatchEvent(new Event("ft-queue-changed"));
}

export function getPendingCount() {
  return readQueue().length;
}

export function enqueueRefuel(payload) {
  const q = readQueue();
  q.push({
    id: `pending-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    payload,
    queued_at: new Date().toISOString(),
  });
  writeQueue(q);
}

let flushing = false;
export async function flushQueue({ onSuccess, onError } = {}) {
  if (flushing) return { synced: 0, failed: 0 };
  if (!navigator.onLine) return { synced: 0, failed: 0 };
  flushing = true;
  try {
    let synced = 0;
    let failed = 0;
    let q = readQueue();
    for (const entry of [...q]) {
      try {
        await api.post("/refuels", entry.payload);
        q = q.filter((e) => e.id !== entry.id);
        writeQueue(q);
        synced += 1;
        onSuccess && onSuccess(entry);
      } catch (e) {
        // if server rejects (4xx), drop from queue so it doesn't loop forever
        const status = e?.response?.status;
        if (status && status >= 400 && status < 500) {
          q = q.filter((e2) => e2.id !== entry.id);
          writeQueue(q);
        }
        failed += 1;
        onError && onError(entry, e);
      }
    }
    return { synced, failed };
  } finally {
    flushing = false;
  }
}

export function subscribeQueue(cb) {
  const handler = () => cb(getPendingCount());
  window.addEventListener("ft-queue-changed", handler);
  window.addEventListener("online", handler);
  window.addEventListener("offline", handler);
  return () => {
    window.removeEventListener("ft-queue-changed", handler);
    window.removeEventListener("online", handler);
    window.removeEventListener("offline", handler);
  };
}
